import ResourcesDispatcher from "../config/ResourcesDispatcher";
export default class LeftSideGridAnimations {
    constructor(animationConfigs) {
        this.leftSideGridAnimation = scene.add.spine(animationConfigs.x, animationConfigs.y, ResourcesDispatcher.SPINES.Left_Side_Grid_Animation.jsonKey, ResourcesDispatcher.SPINES.Left_Side_Grid_Animation.atlasKey)
            .setOrigin(animationConfigs.origin)
            .setScale(animationConfigs.scale)
            .setVisible(false);
        this.startX = animationConfigs.startX;
        this.startY = animationConfigs.startY;
    }
    show(isOn) {
        this.leftSideGridAnimation.setPosition(this.startX, this.startY);
        this.leftSideGridAnimation.setVisible(isOn);
        this.idleTimer();
    }
    start(isOn) {
        this.leftSideGridAnimation.setPosition(this.startX, this.startY);
        this.leftSideGridAnimation.setVisible(isOn);
        this.leftSideGridAnimation.animationState.setAnimation(0, "idle", true);
        this.idleTimer();
    }
    idleTimer() {
        // evita timer multipli
        this.idleReset();
        const min = 5000;
        const max = 20000;
        const loop = () => {
            const delayMs = Phaser.Math.Between(min, max);
            this.delayedAnim = scene.time.delayedCall(delayMs, () => {
                if (gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME &&
                    gameLogicVariableManager.getFutureGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME) {
                    //fa partire animazione idle2 una volta e poi idle in loop
                    this.leftSideGridAnimation.animationState.setAnimation(0, "idle2", false);
                    this.leftSideGridAnimation.animationState.addAnimation(0, "idle", true);
                }
                loop();
            });
        };
        loop();
    }
    idleReset() {
        if (this.delayedAnim && !this.delayedAnim.hasDispatched) {
            this.delayedAnim.remove(false);
        }
        this.delayedAnim = undefined;
    }
    //ENTER LINK
    enterLinkSpin() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.leftSideGridAnimation.animationState.setEmptyAnimations(0);
        this.leftSideGridAnimation.animationState.setAnimation(0, "link_enter", false);
        this.leftSideGridAnimation.animationState.addAnimation(0, "link_loop", true);
    }
    //EXIT LINK
    exitLinkSpin() {
        this.leftSideGridAnimation.animationState.setAnimation(0, "link_exit", false);
        this.leftSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    //ENTER FREESPIN
    enterFreeSpin() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.leftSideGridAnimation.animationState.setEmptyAnimations(0);
        this.leftSideGridAnimation.animationState.addAnimation(0, "freespin_loop", true);
    }
    //EXIT FREESPIN
    exitFreeSpin() {
        this.leftSideGridAnimation.animationState.setAnimation(0, "freespin_exit", false);
        this.leftSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    //CELEBRATE WIN
    win() {
        // disattiva eventuali timer di idle per evitare sovrapposizioni
        this.idleReset();
        // ferma qualunque animazione in corso
        this.leftSideGridAnimation.animationState.setEmptyAnimations(0);
        soundManager.play(ResourcesDispatcher.SOUNDS.leftSideGridAudio[this.randomInt(0, ResourcesDispatcher.SOUNDS.leftSideGridAudio.length - 1)]);
        this.leftSideGridAnimation.animationState.setAnimation(0, "win", false);
        this.leftSideGridAnimation.animationState.addAnimation(0, "idle", true);
        this.idleTimer();
    }
    getLeftSideGridAnimation() {
        return this.leftSideGridAnimation;
    }
    //ANIMATION SHOOT
    shoot() {
        return new Promise((resolve) => {
            // stoppa idle timer e qualsiasi animazione in corso
            this.idleReset();
            this.leftSideGridAnimation.animationState.clearTracks();
            this.leftSideGridAnimation.animationState.setEmptyAnimations(0);
            // imposta lo shoot una volta
            soundManager.play(ResourcesDispatcher.SOUNDS.PISTOL_SHOT);
            const entry = this.leftSideGridAnimation.animationState.setAnimation(0, "link_shoot2", false);
            // listener legato al TrackEntry (non globale)
            entry.listener = {
                complete: () => {
                    entry.listener = null; // pulizia
                    resolve(true);
                },
                end: () => {
                    // viene chiamato sia a fine naturale sia se la traccia viene sostituita
                    entry.listener = null;
                    resolve(true);
                },
                interrupt: () => {
                    // in molte pipeline preferisco comunque risolvere per non lasciare Promise pendenti
                    entry.listener = null;
                    resolve(true);
                }
            };
        });
    }
    resetShoot() {
        this.leftSideGridAnimation.animationState.setAnimation(0, "link_loop", true);
    }
    randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
